import React from 'react';

import styles from './styles.module.scss';
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import { useTranslation } from 'react-i18next';
import NotifyStudentsToggle from './EventForm/NotifyStudentsToggle';
import { showsNotifyStudents } from './hooks/notifyStudents';

type PropsDef = {
  actions: any,
  data: any,
  loading?: boolean,
  options?: { notifyStudents: boolean },
  setOptions?: (options: { notifyStudents: boolean }) => void,
};

export default function ConfirmationPrompt(props: PropsDef) {
  const { t } = useTranslation();
  const { data, actions, loading, options, setOptions } = props;
  const buttonStyle = data.operation === 'delete' ? styles.btn_danger : "btn-primary";
  const isRecurring = data?.event?.recurrenceGroupId;

  return (
    <ModalLayout isOpen classNames={`${styles.modal}`}>
      <div className={styles.confirmation_modal_content}>
        <div className={styles.close_button} onClick={actions.onCancel}>
          <i className="ico ico-x" />
        </div>
        <div className={styles.title}>
          {props.data.operation === 'delete' ? <i className={`ico ico-calendar-x ${styles.danger}`} /> : <i className="ico ico-pencil-o" />}
          <h2>{props.data.title}</h2>
        </div>
        <div className={styles.content}>
          {props.data.content}
        </div>
        {setOptions && showsNotifyStudents(data) && (
          <NotifyStudentsToggle
            checked={options?.notifyStudents ?? true}
            onChange={(notifyStudents) => setOptions({ notifyStudents })}
          />
        )}
        <div className={styles.actions}>
          <button
            type="button"
            className={`btn ${buttonStyle}`}
            onClick={actions.onConfirm}
            disabled={loading}
            data-testid={data.operation === 'delete' ? 'delete-confirm-button' : 'edit-confirm-button'}
          >
            {loading ? <span className={styles.spinner_dark} /> : (isRecurring ? t('Only this') : t('Confirm'))}
          </button>
          {isRecurring && <button type="button" className={`btn ${buttonStyle}`} onClick={actions.onConfirmFollowing} disabled={loading}>{t('This and following')}</button>}
          <button type="button" className={`btn ${styles.cancel_button}`} onClick={actions.onCancel} disabled={loading}>{t('Cancel')}</button>
        </div>
      </div>
    </ModalLayout>
  );
}
